import jQuery from 'jquery';

export default function clubs() {
    jQuery(() => {
        const $ = jQuery;
        const headerOffset = 62;

        $('.tile-menu:not(.gfx) .tile-menu-item')
            .on('click', (e) => {
                e.preventDefault();
                $('.tile-menu-club-list')
                    .remove();

                $('.tile-menu-item').removeClass('active');

                const that = e.currentTarget;

                const parentList = $(that).closest('ul');
                const elementBounding = that.getBoundingClientRect();
                const elementPosition = $(that).index();
                const clubBarIntPos = elementPosition + Math.round(($(parentList).width() - elementBounding.left) / $(that).outerWidth(true));
                const elementTitle = $(that).data('label');
                let barPosition = `:nth-child(${clubBarIntPos})`;

                if (clubBarIntPos > parentList.find('li').length) {
                    barPosition = ':last-child';
                }


                $.ajax({
                    url: '/api/clubs/',
                    type: 'GET',
                    data: `category_id[]=${$(that)
                        .data('category')}`,
                    beforeSend() {
                        $(that)
                            .find('i')
                            .after('<div class="loading"><span class="spinner" style="width:100%;height:100%"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span></div>');
                    },
                    success(response) {
                        if (response) {
                            const clubList = response.clubs;
                            let clublistHtml = '';

                            for (const club in clubList) {
                                if (clubList.hasOwnProperty(club)) {
                                    const clubUrl = clubList[club].path;
                                    const clubLogo = clubList[club].photo_url;
                                    const clubName = clubList[club].name != null ? clubList[club].name : '';

                                    clublistHtml += `<li class="tile-menu-club-item">
                                                            <figure class="tile-menu-figure">
                                                                <img src="${clubLogo}" alt="${clubName}" />
                                                            </figure>
                                                            <a href="${clubUrl}" title="Bezpośredni odnośnik do ${clubName}"><span>${clubName}</span></a>
                                                        </li>`;
                                }
                            }


                            $(that).parent().find(`.tile-menu-item${barPosition}`)
                                .after(`
                                        <div class="tile-menu-club-list">
                                        <div class="tile-menu-container"><h2 class="tile-menu-title">${elementTitle}</h2></div>
                                        <a href="#" class="tile-menu-club-list-close"><span>Zamknij</span></a>
                                        <ul class="tile-menu noMargin">${clublistHtml}</ul>
                                        </div>
                                    `);

                            $(that).addClass('active');

                            $(that).siblings('.tile-menu-club-list')
                                .slideDown('slow', function () {
                                    $('html, body')
                                        .animate({
                                            scrollTop: $(this)
                                                .offset().top - headerOffset,
                                        }, 500);
                                });
                        }
                    },
                    error(response) {


                    },
                    complete() {
                        $(that)
                            .find('.loading')
                            .remove();
                    },
                });
            });

        function closeBar(barElement) {
            $('.tile-menu-item').removeClass('active');

            $(barElement).each(function () {
                $(this).slideUp('slow', function () {
                    $(this)
                        .remove();
                });
            });
        }

        $(window).resize(() => {
            closeBar($('.tile-menu-club-list'));
        });

        $(document)
            .on('click', '.tile-menu-club-list-close', (e) => {
                e.preventDefault();
                const that = e.currentTarget;

                closeBar($(that).closest('.tile-menu-club-list'));
            });
    });
}
